export interface UserInfo {
    action: string
    agentId: string
    assignedAt: number
    completedAt: number
    countedAt: number
    eventType: string
    externalId: string
    id: string
    isAutomaticAction: boolean
    occurredAt: number
    receivedAt: number
    status: string
    userId: string
    zoneId: string
    activityScore: string
    userCategory: string
}

export interface UserStats {
    userId: string
    zoneId: string
    badPhotoCounter: number
    badParkingCounter: number
    noPhotoCounter: number
    abandonedVehicleCounter: number
    totalBadPhoto: number
    totalBadParking: number
    totalNoPhoto: number
    totalAbandonedVehicle: number
    totalReviews: number
}

export interface UserParkingHistory {
    action: ACTIONS
    badParking: boolean
    badPhoto: boolean
    noPhoto: boolean
    abandonedVehicle: boolean
    photoUrl: string
    reviewCompletedAt: number
    reviewId: string
    reviewedBy: string
    rideId: string
    userId: string
    zoneId: string
}

export interface GetSafetyControlSystemDataResponse {
    data: {
        review: {
            action: string
            agent_id: string
            assigned_at: number
            completed_at: number
            counted_at: number
            event_type: string
            external_id: string
            id: string
            is_automatic_action: boolean
            occurred_at: number
            received_at: number
            status: string
            user_id: string
            zone_id: string
        }
        activity_score: number
        user_category: string
    } | null
}

export interface GetUserStatsResponse {
    data: {
        user_id: string
        zone_id: string
        bad_photo_counter: number
        bad_parking_counter: number
        no_photo_counter: number
        abandoned_vehicle_counter: number
        total_bad_photo: number
        total_bad_parking: number
        total_no_photo: number
        total_abandoned_vehicle: number
        total_reviews: number
    }
}

export interface GetUserParkingHistoryResponse {
    data: {
        action: string
        bad_parking: boolean
        bad_photo: boolean
        no_photo: boolean
        abandoned_vehicle: boolean
        photo_url: string
        review_completed_at: number
        review_id: string
        reviewed_by: string
        ride_id: string
        user_id: string
        zone_id: string
    }[]
}

export enum INFRACTION_KIND {
    BAD_PARKING = 'BAD_PARKING',
    BAD_PHOTO = 'BAD_PHOTO',
    NO_PHOTO = 'NO_PHOTO',
    ABANDONED_VEHICLE = 'ABANDONED_VEHICLE',
    TANDEM_RIDE = 'TANDEM_RIDE',
    PAVEMENT_RIDE = 'PAVEMENT_RIDE',
}

export enum INFRACTION_KIND_DESCRIPTION {
    BAD_PARKING = 'Bad parking',
    BAD_PHOTO = 'Bad photo',
    NO_PHOTO = 'No photo',
    ABANDONED_VEHICLE = 'Abandoned vehicle',
    TANDEM_RIDE = 'Tandem ride',
    PAVEMENT_RIDE = 'Pavement ride',
}

export enum ACTIONS {
    UNKNOWN_ACTION = 'UNKNOWN_ACTION',
    NO_ACTION = 'NO_ACTION',
    INFORM = 'INFORM',
    WARN = 'WARN',
    FINE = 'FINE',
}

export enum ACTIONS_DESCRIPTION {
    UNKNOWN_ACTION = 'Pending',
    NO_ACTION = 'None',
    INFORM = 'Info',
    WARN = 'Warn',
    FINE = 'Fine',
}

// The safety-control proto's zero-value action is "UNKNOWN_ACTION" — kept
// distinct from NO_ACTION so the UI can tell the difference between "proto
// zero-value / not set" and an explicit "no action was taken".
export const fromWireAction = (wire: string): ACTIONS => {
    if (Object.values(ACTIONS).includes(wire as ACTIONS)) {
        return wire as ACTIONS
    }
    return ACTIONS.UNKNOWN_ACTION
}

// Returns null for unknown or unsupported values so callers can choose not to render them.
export const fromWireInfractionKind = (wire: string): INFRACTION_KIND | null => {
    switch (wire) {
        case INFRACTION_KIND.BAD_PARKING:
        case INFRACTION_KIND.BAD_PHOTO:
        case INFRACTION_KIND.NO_PHOTO:
        case INFRACTION_KIND.ABANDONED_VEHICLE:
        case INFRACTION_KIND.TANDEM_RIDE:
        case INFRACTION_KIND.PAVEMENT_RIDE:
            return wire
        default:
            return null
    }
}
